import { render, staticRenderFns } from "./Pub.vue?vue&type=template&id=184be9e4&scoped=true"
import script from "./Pub.vue?vue&type=script&lang=js"
export * from "./Pub.vue?vue&type=script&lang=js"
import style0 from "./Pub.vue?vue&type=style&index=0&id=184be9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184be9e4",
  null
  
)

export default component.exports